import { Group } from 'konva/lib/Group';
import { COLORS, SEAT_SIZE, SQUARE_ROTATION } from '../constants';
import { Rect } from 'konva/lib/shapes/Rect';
import { Circle } from 'konva/lib/shapes/Circle';

class TableSquare {
	options: any = {};
	draggable = true;
	element = new Group({
		draggable: true,
	});
	shape: any;
	seats: any;
	rotation = SQUARE_ROTATION.HORIZONTAL;
	private step = 30;
	constructor(options: any = {}) {
		this.options = options;
		this.rotation = this.options.rotation || this.rotation;

		this.initShape();
		this.initWidth();
		this.initSeats();
		this.reorder();
		this.rotate(this.rotation);
	}

	private initShape() {
		let height = 60;
		if(this.options.size == 'm'){
			height = 80;
		}

		this.shape = new Rect({
			x: 0,
			y: 0,
			width: 60,
			height: height,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 2,
			cornerRadius: 2,
		});

		this.element.add(this.shape);
	}

	private initSeats() {
		let seats = new Group({name: 'seats'});
		this.seats = seats;
		const step = this.step;
		const initialX = this.shape.x();
		for (let i = 0; i < this.options.capacity; i++) {
			const seat = new Circle({
				x: 0,
				y: 0,
				radius: SEAT_SIZE,
				fill: COLORS.SEATS.INACTIVE,
			});

			if (i == 0) {
				seat.y(this.shape.y() + this.shape.height() / 2);
			}
			if (i == 1) {
				seat.x(this.shape.width());
				seat.y(this.shape.y() + this.shape.height() / 2);
			}
			if (i >= 2) {
				seat.x((initialX + step + 20) * (i - 1) - 20);
			}
			if (i >= 2 + this.options.capacity / 2 - 1) {
				const half = i - this.options.capacity / 2;
				seat.x(((initialX * half + step + 20) * half) - 20);
				seat.y(this.shape.y() + this.shape.height());
			}
			seats.add(seat);
		}

		this.element.add(seats);
	}

	private initWidth() {
		const step = this.step;
		const innerStep = 50;
		const capacity = this.options.capacity - 3;

		if (capacity > 0) {
			this.shape.width(step + (capacity / 2) * innerStep + 5);
		} else {
			this.shape.width(60);
		}
	}

	private reorder() {
		this.element.children[1].zIndex(0);
	}

	rotate(rType: string) {
		if (!rType) {
			return;
		}

		this.rotation = rType;

		// this.element.rotate(-this.element.rotation());

		if (rType == SQUARE_ROTATION.HORIZONTAL) {
			return;
		}
		if (rType == SQUARE_ROTATION.VERTICAL) {
			// this.element.rotate(90);
			return;
		}
	}
}

export default TableSquare;
